<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Pro Did Not Show Up'"
      [canGoBack]="false"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-row [align]="'center'" class="extra-bottom-padding">
      <tidy-text
        [body]="'Oh no! Please confirm that'" /><span>&nbsp;</span>
        <tidy-text
          [body]="proName" />
        <tidy-text
          [body]="'did not clean at all and should not be paid for this cleaning.'" />
      </tidy-row>

      <tidy-card>
        <tidy-row>
          <tidy-checkbox
            [(checked)]="getCredit"
          [items]="[
            {
              viewValue: 'Add $10 credit to my account', value: true
            }
          ]"
          [initValue]="getCredit" />
      </tidy-row>
      <tidy-row>
        <tidy-checkbox
          [(checked)]="blockPro"
          [items]="[
            {
              viewValue: 'Block Pro ' + proName, value: true
            }
          ]"
        [initValue]="blockPro" />
    </tidy-row>
  </tidy-card>

  @if (errorMessage) {
    <tidy-error-message
      [text]="errorMessage" />
  }

  <tidy-row class="align-right">
    <tidy-button
      [text]="'Go Back'"
      [action]="boundGoBack"
      class="secondary" />
    <tidy-button
      [text]="'Confirm'"
      [action]="boundSubmit"
      class="primary" />
  </tidy-row>

</tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
